import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { IGetAllServiceProps } from "@api/types/globalService.types";
import { useQuery } from "@tanstack/react-query";
import useGlobalDebounceHandler from "../useGlobalDebounceHandler";
import { useState } from "react";
import {
  getAllTransmissionTypesAPI,
  getSingleTransmissionTypesAPI,
} from "./transmissionTypes.api";

type ITransmissionTypesServiceProps = Omit<IGetAllServiceProps, "stage_id">;

const useAllTransmissionTypesService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cacheKeys = [],
  filters,
}: ITransmissionTypesServiceProps) => {
  const [searchTransmissionTypesQuery, setSearchTransmissionTypesQuery] =
    useState<string>("");

  const { debouncedQuery } = useGlobalDebounceHandler(
    searchTransmissionTypesQuery
  );
  const allTransmissionTypesService = useQuery({
    queryKey: [...CACHE_KEYS.TRANSMISSION_TYPE, page, per_page, ...cacheKeys],
    queryFn: () =>
      getAllTransmissionTypesAPI({
        searchParams: {
          "filter[name]": debouncedQuery,
          page,
          per_page,
          ...filters,
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchTransmissionTypesQuery, setSearchTransmissionTypesQuery },
    services: { allTransmissionTypesService },
  };
};

const useSingleTransmissionTypesService = ({
  singleTransmissionTypesId,
  enableQuery = true,
}: {
  singleTransmissionTypesId: string;
  enableQuery?: boolean;
}) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.TRANSMISSION_TYPE, singleTransmissionTypesId],
    queryFn: () => getSingleTransmissionTypesAPI(singleTransmissionTypesId),
    enabled: !!singleTransmissionTypesId && enableQuery,
  });
};

export { useAllTransmissionTypesService, useSingleTransmissionTypesService };
